module.exports = __webpack_public_path__ + "img/logo-bottom.596c96ed.png";